'use strict';

jQuery(($) => {
    const $previewer = $('.previewer');

    if ($previewer.length) {
        require.ensure([], require => {
            require([], () => {
                $previewer.each(function (i, container) {
                    let $container = $(container);

                    $container.find('.js-load-more')
                        .on('click', function () {
                            let $button = $(this);

                            $button.prop('disabled', true);
                            $container.addClass('is-loading');
                            setTimeout(() => {
                                let id = $button.data('lazies');

                                $button.remove();

                                $(`#${id}`).children().remove().appendTo($container.find('.previewer__posts'));

                                $container.removeClass('is-loading');
                            }, 350);
                        });
                });
            });
        }, 'previewer');
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/lib/layouts/previewer.js